import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export function WorkSlideshow({ images }) {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const count = images.length;

  useEffect(() => {
    if (paused || count < 2) return undefined;
    const t = setInterval(() => setIndex((i) => (i + 1) % count), 4000);
    return () => clearInterval(t);
  }, [paused, count]);

  if (!count) return null;
  const go = (d) => setIndex((i) => (i + d + count) % count);

  return (
    <div
      data-testid="work-slideshow"
      className="relative rounded-[2rem] overflow-hidden shadow-2xl bg-cream"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      <div className="relative aspect-[4/5] sm:aspect-[4/3] w-full">
        {images.map((img, i) => (
          <img
            key={img.url}
            src={img.url}
            alt={img.tag || "Makeup work by The Velvet Brush"}
            loading={i === 0 ? "eager" : "lazy"}
            data-testid={i === index ? "slide-active" : `slide-${i}`}
            className={`absolute inset-0 w-full h-full object-cover object-[50%_30%] transition-opacity duration-700 ease-in-out ${
              i === index ? "opacity-100" : "opacity-0"
            }`}
          />
        ))}
      </div>
      {images[index].tag && (
        <span
          data-testid="slide-caption"
          className="absolute bottom-4 left-4 bg-ivory/85 backdrop-blur text-ink text-xs font-semibold px-4 py-2 rounded-full"
        >
          {images[index].tag}
        </span>
      )}
      <button
        data-testid="slide-prev"
        onClick={() => go(-1)}
        aria-label="Previous photo"
        className="absolute left-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-ivory/85 backdrop-blur flex items-center justify-center text-ink hover:bg-ivory active:scale-95 transition-[background-color,transform] duration-200"
      >
        <ChevronLeft className="w-5 h-5" />
      </button>
      <button
        data-testid="slide-next"
        onClick={() => go(1)}
        aria-label="Next photo"
        className="absolute right-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-ivory/85 backdrop-blur flex items-center justify-center text-ink hover:bg-ivory active:scale-95 transition-[background-color,transform] duration-200"
      >
        <ChevronRight className="w-5 h-5" />
      </button>
      <div className="absolute bottom-4 right-4 flex gap-1.5">
        {images.map((_, i) => (
          <button
            key={i}
            data-testid={`slide-dot-${i}`}
            onClick={() => setIndex(i)}
            aria-label={`Go to photo ${i + 1}`}
            className={`h-2 rounded-full transition-[width,background-color] duration-300 ${
              i === index ? "w-6 bg-velvet" : "w-2 bg-ivory/70 hover:bg-ivory"
            }`}
          />
        ))}
      </div>
    </div>
  );
}
